import {SiteId} from "@app/shared/services/api/access-sites.interface";
import {CacheById} from "../cache-by-id";
import {AlertNotification, AlertNotificationSearchTerm, NotificationService, SiteNotificationId} from "@app/shared/services/api/notification.service";
import {from, map, mergeMap, Observable, of, reduce} from "rxjs";
import {HttpUtilityService} from "@app/shared/services/api/http-utility-service";
import {AlertNotificationByIdCache} from "./alert-notification-by-id-cache";
import {CollectionUtils} from "@app/shared/util/collections/collection-utils";

export class SiteNotificationIdsBySiteIdCache extends CacheById<SiteId, SiteNotificationId[]> {
  constructor(
    httpUtilityService: HttpUtilityService,
    notificationService: NotificationService,
    partitionSize: number,
    alertNotificationByIdCache: AlertNotificationByIdCache,
    alertNotificationDefaultParameters: AlertNotificationSearchTerm = AlertNotificationByIdCache.ALERT_NOTIFICATION_DEFAULT_PARAMETERS
  ) {
    super(siteIds => from(siteIds).pipe(
      mergeMap(siteId =>
        httpUtilityService.pageUntilComplete(
          pageInfo => notificationService.searchAlertNotifications(
            { limit: pageInfo.rows, start_index: pageInfo.first },
            { site_ids: [siteId], ...alertNotificationDefaultParameters }
          ),
          { first: 0, rows: partitionSize }
        ).pipe(map((alertNotifications): [SiteId, Map<SiteNotificationId, AlertNotification>] => [siteId, CollectionUtils.indexBy(alertNotifications, 'sites_notification_id')]))
      ),
      reduce((alertNotificationsBySiteId, [siteId, alertNotificationById]) => {
        alertNotificationsBySiteId.set(siteId, alertNotificationById);
        return alertNotificationsBySiteId;
      }, new Map<SiteId, Map<SiteNotificationId, AlertNotification>>()),
      mergeMap(alertNotificationByIdBySiteId => {
        const alertNotificationById: Map<SiteNotificationId, Observable<AlertNotification>> = new Map();
        const siteNotificationIdsBySiteId: Map<SiteId, SiteNotificationId[]> = new Map();
        alertNotificationByIdBySiteId.forEach((siteAlertNotificationById, siteId) => {
          siteAlertNotificationById.forEach((alertNotification, siteNotificationId) =>
            alertNotificationById.set(siteNotificationId, of(alertNotification)));
          siteNotificationIdsBySiteId.set(siteId, Array.from(siteAlertNotificationById.keys()));
        });
        return alertNotificationByIdCache.setItems(alertNotificationById).pipe(map(() => siteNotificationIdsBySiteId));
      })
    ));
  }
}